module.exports = __webpack_public_path__ + "static/img/headerBgNew.9abad90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/headerBgNew.png
// module id = /76i
// module chunks = 1